/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setthepriceandcapacityforyourevent7Inputs */

const en_setthepriceandcapacityforyourevent7 = /** @type {(inputs: Setthepriceandcapacityforyourevent7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set the price and capacity for your event`)
};

const de_setthepriceandcapacityforyourevent7 = /** @type {(inputs: Setthepriceandcapacityforyourevent7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg Preis und Kapazität für dein Event fest.`)
};

/**
* | output |
* | --- |
* | "Set the price and capacity for your event" |
*
* @param {Setthepriceandcapacityforyourevent7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setthepriceandcapacityforyourevent7 = /** @type {((inputs?: Setthepriceandcapacityforyourevent7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setthepriceandcapacityforyourevent7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setthepriceandcapacityforyourevent7(inputs)
	return de_setthepriceandcapacityforyourevent7(inputs)
});
export { setthepriceandcapacityforyourevent7 as "setThePriceAndCapacityForYourEvent" }